<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[1]" :innerTitle="navList[1].navChildList[1].name" :innerLink="navList[1].navChildList[1].toLink"></inner-nav>
      <div class="speech-content">
        <img :src="speechInfo.imgUrl" alt="">
        <div class="introduce">
          <div>
            <h2>{{speechInfo.userName}}</h2>
            <h3>{{speechInfo.job}}</h3>
          </div>
          <div v-html="speechInfo.content">
            {{speechInfo.content}}
          </div>


        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        speechInfo: {}
      }
    },
    components: {
      ad,
      InnerNav
    },
    created(){
      this.$http.get(`/outer/feifan/getDirectorInfo.do`).then((res)=>{
        this.speechInfo=res.data
      })
    }
  }
</script>

<style scoped lang="less">

  .speech-content{
    overflow: hidden;
    clear: both;
    padding:.3rem 0;
      img{
        width:3.4rem;
        height:4.4rem;
      }
      .introduce{
        width:8.3rem;
        float: right;
          div:nth-child(1){
            font-family:PingFangSC-Medium;
            padding-bottom:.17rem;
              h2{
                font-size:.24rem;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:.24rem;
              }
              h3{
                font-size:.14rem;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:.3rem;
              }
          }
          div:nth-child(2){
            text-align: justify;
            padding-top: .1rem;
            border-top:1px solid rgba(204,204,204,1);
            width:100%;
            font-size:.12rem;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:.24rem;
          }
      }

  }

</style>



// WEBPACK FOOTER //
// src/pages/group/speech.vue